<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-text>
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="text-h5">
                {{ isModoMoldesReasignacion ? 'Reasignar Operaciones Moldes' : 'Reasignar Operacion' }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ isModoMoldesReasignacion ? selectedRows.length + ' renglon(es) seleccionados' : editedItem.nombre }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-row>
            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6">Estatus</v-list-item-title>
                  <v-list-item-subtitle class="mt-1">
                    <v-chip small label class="elevation-0" :color="editedItem.asignado ? 'success' : 'grey lighten-1'"
                      :text-color="editedItem.asignado ? 'white' : 'black'">
                      {{ editedItem.asignado ? 'Asignado' : 'Por asignar' }}
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>

            <v-col cols="6">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="text-h6">Token (Cavidad)</v-list-item-title>
                  <v-list-item-subtitle class="mt-1">
                    <v-chip small label class="elevation-0" color="grey lighten-1" text-color="white">
                      {{ editedItem.token }}
                    </v-chip>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-card-text>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle>Fecha Inicio</v-list-item-subtitle>
                <v-list-item-title style="font-weight: 600; color: #616161;">{{ editedItem.inicio }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-subtitle>Fecha Fin</v-list-item-subtitle>
                <v-list-item-title style="font-weight: 600; color: #616161;">{{ editedItem.fin }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text>
            <v-row align="center" justify="center" class="text-center">
              <v-col cols="12" class="text-h4">Cantidad por asignar</v-col>
              <v-col cols="12" class="text-h2">
                {{ isModoMoldesReasignacion ? cantidadSeleccionadaMoldes : editedItem.cantidad }}
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text>
            <v-row align="center" justify="center" class="text-center">
              <v-col cols="12">
                <v-autocomplete v-model="selectedOrden" :items="ordenesOptions"
                  :disabled="loaderChange || editedItem.asignado" label="Orden de trabajo" item-text="text"
                  item-value="value" @change="onOrdenChange">
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-chip v-if="item.tipoReasignacion" x-small class="mr-2"
                          :color="getTipoReasignacionColor(item.tipoReasignacion)" text-color="white">
                          {{ getTipoReasignacionText(item.tipoReasignacion) }}
                        </v-chip>
                        {{ item.otText || item.text }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-chip v-if="item.tipoReasignacion" x-small class="mr-2"
                      :color="getTipoReasignacionColor(item.tipoReasignacion)" text-color="white">
                      {{ getTipoReasignacionText(item.tipoReasignacion) }}
                    </v-chip>
                    {{ item.otText || item.text }}
                  </template>
                </v-autocomplete>
              </v-col>

              <template v-if="!isModoMoldesReasignacion">
              <v-col cols="12">
                <v-autocomplete v-model="selectedDetalle" :items="detalleOptions" label="Artículo" item-text="text"
                  item-value="value" :disabled="!selectedOrden || loaderChange || editedItem.asignado"
                  @change="onDetalleChange"></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-autocomplete v-model="selectedOperacion" :items="operacionOptions" label="Operación" item-text="text"
                  item-value="value"
                  :disabled="!selectedDetalle || loaderChange || editedItem.asignado"></v-autocomplete>
              </v-col>
              </template>
              <template v-else>
              <v-col cols="12">
                <v-autocomplete v-model="selectedDetallesMoldes" :items="detalleOptions" label="Articulos"
                  item-text="text" item-value="value" multiple chips small-chips readonly disabled></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-autocomplete v-model="selectedOperacionesMoldes" :items="operacionesMoldesOptions"
                  label="Operaciones" item-text="text" item-value="value" multiple chips small-chips readonly
                  disabled></v-autocomplete>
              </v-col>
              </template>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" :loading="loaderChange" :disabled="loaderChange" text @click="dialog = false">
            {{ editedItem.asignado ? 'Cerrar' : 'Cancelar' }}
          </v-btn>
          <v-btn color="red darken-1" :loading="loaderChange" :disabled="loaderChange || !puedeGuardar" v-if="!editedItem.asignado" text
            @click="save()">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPreviewMoldes" max-width="900px">
      <v-card>
        <v-card-title>Vista previa reasignacion moldes</v-card-title>
        <v-card-subtitle>
          {{ previewMoldes.length }} renglón(es), {{ totalCavidadesPreview }} cavidad(es)/token(s)
        </v-card-subtitle>
        <v-card-text>
          <v-alert v-if="previewMoldesErrores.length" type="warning" dense text>
            {{ previewMoldesErrores.length }} articulo(s) no se pudieron procesar y no se van a guardar.
          </v-alert>

          <v-alert v-if="!previewMoldes.length" type="info" dense text>
            No hay cavidades para mostrar.
          </v-alert>

          <v-expansion-panels v-else multiple>
            <v-expansion-panel v-for="(item, previewIndex) in previewMoldes" :key="item.idDatoNoAsignado + '-' + previewIndex">
              <v-expansion-panel-header>
                <div>
                  <div class="font-weight-medium">
                    {{ item.maquina }} - {{ item.tokenOrigen || 'Sin token origen' }}
                  </div>
                  <div class="text-caption grey--text">
                    {{ item.inicio }} - {{ item.fin }} | Cantidad: {{ item.cantidad }} |
                    {{ (item.cavidades || []).length }} cavidad(es)
                  </div>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th>Maquina</th>
                      <th>Token</th>
                      <th>Cavidad</th>
                      <th>OT</th>
                      <th>Fallback</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="cavidad in (item.cavidades || [])" :key="item.idDatoNoAsignado + '-' + previewIndex + '-' + cavidad.idTokenExtra">
                      <td>{{ cavidad.maquina }}</td>
                      <td>{{ cavidad.token }}</td>
                      <td>{{ cavidad.cavidad }}</td>
                      <td>{{ cavidad.idTrabajoOrden }}</td>
                      <td>
                        <v-chip x-small :color="cavidad.esFallback ? 'warning' : 'success'" text-color="white">
                          {{ cavidad.esFallback ? 'Si' : 'No' }}
                        </v-chip>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text :disabled="loaderChange" @click="backToMoldesForm">
            Regresar
          </v-btn>
          <v-btn color="red darken-1" text :loading="loaderChange" :disabled="loaderChange || !previewMoldes.length"
            @click="saveMoldes">
            Confirmar y guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Tabla -->
    <v-row>
      <v-col cols="3">
        <v-autocomplete v-model="maquinaSeleccionada" :items="tokensMaquinas" item-text="maquina"
          item-value="idMaquinaIns" label="Máquina" @change="onMaquinaChange($event); getDatosSn()" :loading="loadTokensExtras"
          :disabled="loadTokensExtras" clearable return-object />
      </v-col>

      <v-col cols="3">
        <v-autocomplete v-model="tokenSeleccionado" :items="tokensDisponibles" item-text="nombre"
          item-value="idTokenExtra" label="Token" :disabled="!tokensDisponibles.length" :loading="loadTokensExtras"
          return-object clearable @change="getDatosSn"/>
      </v-col>
      <v-col cols="3">
        <VueCtkDateTimePicker id="filtroFechaInicio" v-model="filtros.inicio" label="Fecha Inicio"
          format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora"
          clearable @input="getDatosSn()" />
      </v-col>
      <v-col cols="3">
        <VueCtkDateTimePicker id="filtroFechaFin" v-model="filtros.fin" label="Fecha Fin" format="YYYY-MM-DD HH:mm"
          formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora" clearable @input="getDatosSn(1)" />
      </v-col>
      <v-col cols="3">
        <v-autocomplete v-model="filtros.estado" :items="[
          { text: 'Activo', value: true },
          { text: 'Inactivo', value: false }
        ]" item-text="text" item-value="value" label="Estado" @input="getDatosSn()"/>
      </v-col>
      <v-col cols="12">
        <v-btn v-if="isModoMoldesReasignacion" color="primary" class="mb-3" :disabled="!selectedRows.length || loaderData"
          @click="openSelectedMoldes">
          Reasignar seleccionados ({{ selectedRows.length }})
        </v-btn>
        <v-data-table v-model="selectedRows" :headers="headers" :items="desserts" :loading="loaderData"
          :show-select="isModoMoldesReasignacion" item-key="idDatoNoAsignado" item-disabled="asignado">
          <template v-slot:item.asignado="{ item }">
            <v-chip v-if="item.asignado" color="green" text-color="white">Asignado</v-chip>
            <v-chip v-else color="red" text-color="white">Sin Asignar</v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">mdi-braille</v-icon>
            <!-- <v-icon small @click="deleteItem(item)">mdi-delete</v-icon> -->
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  data: () => ({
    maquinaSeleccionada: null,
      tokensDisponibles: [],
      tokenSeleccionado: null,
    filtros: {
      inicio: null,
      fin: null,
      estado: false
    },
    loaderChange: false,
    loaderData: false,
    dialog: false,
    dialogPreviewMoldes: false,
    dialogDelete: false,
    selectedRows: [],
    selectedTokens: [],
    selectedDetallesMoldes: [],
    selectedOperacionesMoldes: [],
    previewMoldes: [],
    previewMoldesPayloads: [],
    previewMoldesErrores: [],

    selectedOrden: null,
    selectedDetalle: null,
    selectedOperacion: null, // 👈 ahora es un objeto completo o null

    ordenesOptions: [],
    detalleOptions: [],
    operacionOptions: [],
    operacionesMoldesOptions: [],

    headers: [
      { text: 'Maquina Instancia', align: 'center', value: 'nombre', sortable: false },
      { text: 'Token Asignado', value: 'token', align: 'center', sortable: false },
      { text: 'Inicio', value: 'inicio', align: 'center', sortable: false },
      { text: 'Fin', value: 'fin', align: 'center', sortable: false },
      { text: 'Cantidad Reportada', value: 'cantidad', align: 'center', sortable: false },
      { text: 'Estatus', value: 'asignado', align: 'center', sortable: false },
      { text: 'Actions', value: 'actions', align: 'center', sortable: false },
    ],

    desserts: [],
    editedIndex: -1,
    editedItem: {
      asignado: false,
      cantidad: 0,
      fin: null,
      idDatoNoAsignado: null,
      idMaquinaIns: null,
      idTokenExtra: null,
      inicio: null,
      nombre: null,
      token: null,
      idArea: null,
      idTrabajoOrden: null,
      idTrabajoOrdenDetalle: null,
      idOperacion: null
    },
    defaultItem: {},
    odtsOpers: [],
    tokensMaquinas: [],
    loadTokensExtras: false
  }),

  computed: {
    ...mapState(["nombreEmpresa"]),
    isModoMoldesReasignacion() {
      return ["CAZEL-TLT", "Cazel"].includes(this.nombreEmpresa);
    },
    cantidadSeleccionadaMoldes() {
      return this.selectedRows.reduce((total, item) => total + Number(item.cantidad || 0), 0);
    },
    totalCavidadesPreview() {
      return this.previewMoldes.reduce((total, item) => total + ((item.cavidades || []).length), 0);
    },
    puedeGuardar() {
      if (this.isModoMoldesReasignacion) {
        return Boolean(
          this.selectedOrden &&
          this.selectedOperacionesMoldes.length &&
          this.selectedRows.length
        );
      }

      return Boolean(
        this.selectedOrden &&
        this.selectedDetalle &&
        this.selectedOperacion &&
        (!this.isModoMoldesReasignacion || this.selectedRows.length)
      );
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      if (this.isModoMoldesReasignacion) {
        this.odtsOpers = [];
        this.ordenesOptions = [];
      } else {
        this.getOdtsOpers();
      }
      this.getDatosSn();
      this.getMaquinasInsToken();
    },
    refreshDatosSinAsignar() {
      this.getDatosSn();
    },
    onMaquinaChange(maquina) {
      if (maquina) {
        this.tokensDisponibles = maquina.tokensExtras || [];

        // Si solo hay un token → seleccionarlo en automático
        if (this.tokensDisponibles.length === 1) {
          this.tokenSeleccionado = this.tokensDisponibles[0];
        } else {
          this.tokenSeleccionado = null;
        }
      } else {
        this.tokensDisponibles = [];
        this.tokenSeleccionado = null;
      }
    },
    getDatosSn(trigger = null) {
      this.loaderData = true;

      axios.get("/DatosSinAsignar", {
        params: {
          IdMaquinaIns: this.maquinaSeleccionada ? this.maquinaSeleccionada.idMaquinaIns : null,
          IdTokenExtra: this.tokenSeleccionado ? this.tokenSeleccionado.idTokenExtra : null,
          Inicio: this.filtros.inicio,          // string o Date en ISO
          Fin: this.filtros.fin,                // string o Date en ISO
          Estado: this.filtros.estado ?? false
        }
      })
        .then(res => this.desserts = res.data)
        .finally(() => this.loaderData = false);
    },

    getOdtsOpers() {
      axios.get("/TrabajoOrdenes/OtsAll")
        .then(res => {
          this.odtsOpers = res.data;
          this.ordenesOptions = this.odtsOpers.map(o => ({
            text: `${o.ot} ${o.clave}`,
            value: o.idTrabajoOrden,
            detalles: o.odtd
          }));
          if (this.ordenesOptions.length === 1) {
            this.selectedOrden = this.ordenesOptions[0].value;
            this.onOrdenChange(this.selectedOrden);
          }
        });
    },
    getOtsReasignacionMoldes(item) {
      this.loaderChange = true;
      this.odtsOpers = [];
      this.ordenesOptions = [];
      this.detalleOptions = [];
      this.operacionOptions = [];
      this.operacionesMoldesOptions = [];
      this.selectedOrden = null;
      this.selectedDetalle = null;
      this.selectedOperacion = null;
      this.selectedDetallesMoldes = [];
      this.selectedOperacionesMoldes = [];

      return axios.get(`/Reportes/OtsReasignacionMoldes/${item.idDatoNoAsignado}`)
        .then(res => {
          this.odtsOpers = res.data || [];
          this.ordenesOptions = this.odtsOpers.map(o => ({
            text: `${this.getTipoReasignacionText(o.tipoReasignacion)} - ${o.ot} ${o.clave}`,
            otText: `${o.ot} ${o.clave}`,
            value: o.idTrabajoOrden,
            detalles: o.odtd,
            tipoReasignacion: o.tipoReasignacion
          }));

          if (this.ordenesOptions.length === 1) {
            this.selectedOrden = this.ordenesOptions[0].value;
            this.onOrdenChange(this.selectedOrden);
          }
        })
        .finally(() => this.loaderChange = false);
    },
    getMaquinasInsToken() {
      this.loadTokensExtras = true;
      axios.get("/Maquinas/MaquinasInstanciasTokens")
        .then(res => {
          this.tokensMaquinas = res.data;
          this.loadTokensExtras = false;
        });
    },
    getTipoReasignacionText(tipo) {
      const labels = {
        pasada: "Pasada",
        en_curso: "En curso",
        siguiente: "Siguiente"
      };
      return labels[tipo] || "OT";
    },
    getTipoReasignacionColor(tipo) {
      const colors = {
        pasada: "blue darken-1",
        en_curso: "green darken-1",
        siguiente: "deep-orange darken-1"
      };
      return colors[tipo] || "grey";
    },
    onOrdenChange(idOrden) {
      this.selectedDetalle = null;
      this.selectedOperacion = null;
      this.detalleOptions = [];
      this.operacionOptions = [];
      this.operacionesMoldesOptions = [];
      this.selectedDetallesMoldes = [];
      this.selectedOperacionesMoldes = [];

      const orden = this.odtsOpers.find(o => o.idTrabajoOrden === idOrden);
      if (!orden) return;

      this.detalleOptions = orden.odtd.map(d => ({
        text: d.codigoArticulo ? `[${d.codigoArticulo}] - ${d.nombreArticulo}` : d.nombreArticulo,
        value: d.idTrabajoOrdenDetalle,
        operaciones: d.operacionesAll
      }));

      if (this.isModoMoldesReasignacion) {
        this.applyDetalleDefaultsMoldes();
        return;
      }

      if (this.detalleOptions.length === 1) {
        this.selectedDetalle = this.detalleOptions[0].value;
        this.onDetalleChange(this.selectedDetalle);
      }
    },

    applyDetalleDefaultsMoldes() {
      this.selectedDetallesMoldes = this.detalleOptions.map(d => d.value);
      this.operacionesMoldesOptions = [];
      this.selectedOperacionesMoldes = [];

      this.detalleOptions.forEach(detalle => {
        const operacion = (detalle.operaciones || [])[0];
        if (!operacion) return;

        const value = {
          idTrabajoOrdenDetalle: detalle.value,
          idOperacion: operacion.idOperacion,
          idArea: operacion.idArea,
          text: detalle.text
        };

        this.operacionesMoldesOptions.push({
          text: `${detalle.text} - ${operacion.codigoArticulo ? `[${operacion.codigoArticulo}] - ${operacion.nombreArticulo}` : operacion.nombreArticulo}`,
          value
        });
        this.selectedOperacionesMoldes.push(value);
      });

      if (this.selectedOperacionesMoldes.length) {
        const primeraOperacion = this.selectedOperacionesMoldes[0];
        this.selectedDetalle = primeraOperacion.idTrabajoOrdenDetalle;
        this.selectedOperacion = {
          idArea: primeraOperacion.idArea,
          idOperacion: primeraOperacion.idOperacion
        };
      }
    },

    onDetalleChange(idDetalle) {
      this.selectedOperacion = null;

      const detalle = this.detalleOptions.find(d => d.value === idDetalle);
      if (!detalle) return;

      this.operacionOptions = detalle.operaciones.map(op => ({
        text: op.codigoArticulo ? `[${op.codigoArticulo}] - ${op.nombreArticulo}` : op.nombreArticulo,
        value: { idOperacion: op.idOperacion, idArea: op.idArea } // 👈 objeto completo
      }));

      if (this.operacionOptions.length === 1) {
        this.selectedOperacion = this.operacionOptions[0].value;
      }
    },

    editItem(item) {
      if (this.isModoMoldesReasignacion) {
        this.openMoldesDialog([item], item);
        return;
      }

      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.selectedOrden = this.editedItem.idTrabajoOrden;
      this.selectedDetalle = this.editedItem.idTrabajoOrdenDetalle;
      this.selectedOperacion = {
        idArea: this.editedItem.idArea,
        idOperacion: this.editedItem.idOperacion
      };
      this.dialog = true;
    },

    openSelectedMoldes() {
      if (!this.selectedRows.length) return;
      this.openMoldesDialog(this.selectedRows, this.selectedRows[0]);
    },

    openMoldesDialog(rows, referenceItem) {
      const rowsSinAsignar = rows.filter(x => !x.asignado);
      if (!rowsSinAsignar.length) return;

      this.selectedRows = rowsSinAsignar;
      this.editedIndex = this.desserts.indexOf(referenceItem);
      this.editedItem = Object.assign({}, referenceItem);
      this.selectedTokens = [];
      this.selectedDetallesMoldes = [];
      this.selectedOperacionesMoldes = [];
      this.previewMoldes = [];
      this.previewMoldesPayloads = [];
      this.previewMoldesErrores = [];
      this.dialog = true;
      this.getOtsReasignacionMoldes(referenceItem);
    },

    backToMoldesForm() {
      this.dialogPreviewMoldes = false;
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.selectedOrden = null;
        this.selectedDetalle = null;
        this.selectedOperacion = null;
        this.selectedTokens = [];
        this.selectedDetallesMoldes = [];
        this.selectedOperacionesMoldes = [];
        this.previewMoldes = [];
        this.previewMoldesPayloads = [];
        this.previewMoldesErrores = [];
      });
    },

    formatDate(dateString) {
      if (!dateString) return null;
      let normalized = dateString.replace("a. m.", "AM").replace("p. m.", "PM");
      const date = new Date(normalized);
      if (isNaN(date.getTime())) return null;
      const dd = String(date.getDate()).padStart(2, "0");
      const MM = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();
      const HH = String(date.getHours()).padStart(2, "0");
      const mm = String(date.getMinutes()).padStart(2, "0");
      return `${dd}/${MM}/${yyyy} ${HH}:${mm}`;
    },

    save() {
      if (this.isModoMoldesReasignacion) {
        return this.previewReasignacionMoldes();
      }

      this.loaderChange = true;
      const reporte = [{
        IdTrabajoOrden: this.selectedOrden,
        IdTrabajoOrdenDetalle: this.selectedDetalle,
        IdArea: this.selectedOperacion.idArea,
        IdOperacion: this.selectedOperacion.idOperacion,
        IdsMaquinasIns: this.editedItem.idMaquinaIns ? [this.editedItem.idMaquinaIns] : [],
        IdTokenExtra: this.editedItem.idTokenExtra || null,
        IdsOperadores: [1],
        Inicio: this.formatDate(this.editedItem.inicio),
        Fin: this.formatDate(this.editedItem.fin),
        Cantidad: this.editedItem.cantidad
      }];

      axios.post("Reportes/ReasignacionOperacion/" + this.editedItem.idDatoNoAsignado, reporte)
        .then(() => {
          this.loaderChange = false;
          this.dialog = false;
          this.refreshDatosSinAsignar();
        })
        .catch(err => console.error(err));
    },

    buildMoldesPayload() {
      return {
        idsDatosNoAsignados: this.selectedRows.map(x => x.idDatoNoAsignado),
        idTrabajoOrden: this.selectedOrden,
        idTrabajoOrdenDetalle: this.selectedDetalle,
        idArea: this.selectedOperacion.idArea,
        idOperacion: this.selectedOperacion.idOperacion,
        idsOperadores: [1],
        idsTokenExtra: this.selectedTokens || [],
        forzarCavidadesVirtuales: false
      };
    },

    buildMoldesPayloads() {
      if (!this.isModoMoldesReasignacion) {
        return [this.buildMoldesPayload()];
      }

      return this.selectedOperacionesMoldes.map(operacion => ({
        idsDatosNoAsignados: this.selectedRows.map(x => x.idDatoNoAsignado),
        idTrabajoOrden: this.selectedOrden,
        idTrabajoOrdenDetalle: operacion.idTrabajoOrdenDetalle,
        idArea: operacion.idArea,
        idOperacion: operacion.idOperacion,
        idsOperadores: [1],
        idsTokenExtra: [],
        forzarCavidadesVirtuales: false
      }));
    },

    buildMoldesBatchPayload() {
      return {
        idsDatosNoAsignados: this.selectedRows.map(x => x.idDatoNoAsignado),
        idTrabajoOrden: this.selectedOrden,
        detalles: this.selectedOperacionesMoldes.map(operacion => ({
          idTrabajoOrdenDetalle: operacion.idTrabajoOrdenDetalle,
          idArea: operacion.idArea,
          idOperacion: operacion.idOperacion
        })),
        idsOperadores: [1],
        idsTokenExtra: [],
        forzarCavidadesVirtuales: false
      };
    },

    previewReasignacionMoldes() {
      this.loaderChange = true;
      const payload = this.buildMoldesBatchPayload();
      this.previewMoldes = [];
      this.previewMoldesPayloads = [];
      this.previewMoldesErrores = [];

      return axios.post("Reportes/PreviewReasignacionOperacionMoldesBatch", payload)
        .then(res => {
          this.previewMoldes = res.data || [];
          this.previewMoldesPayloads = [payload];
          this.dialog = false;
          this.dialogPreviewMoldes = true;
        })
        .catch(err => {
          this.previewMoldesErrores = [{
            text: "No se pudo generar la vista previa batch",
            status: err && err.response ? err.response.status : null
          }];
          console.error(err);
        })
        .finally(() => this.loaderChange = false);
    },

    saveMoldes() {
      this.loaderChange = true;
      const payload = this.previewMoldesPayloads.length ? this.previewMoldesPayloads[0] : this.buildMoldesBatchPayload();
      this.previewMoldesErrores = [];

      return axios.post("Reportes/ReasignacionOperacionMoldesBatch", payload)
        .then(() => {
          this.dialog = false;
          this.dialogPreviewMoldes = false;
          this.selectedRows = [];
          this.previewMoldes = [];
          this.previewMoldesPayloads = [];
          this.previewMoldesErrores = [];
          this.refreshDatosSinAsignar();
        })
        .catch(err => {
          this.previewMoldesErrores = [{
            text: "No se pudo guardar la reasignacion batch",
            status: err && err.response ? err.response.status : null
          }];
          console.error(err);
        })
        .finally(() => {
          this.loaderChange = false;
        });
    }
  }
};
</script>
